import React, { useState } from 'react';
import BlackLogo from '../Images/dsmlogoblack.png';
import * as PATH from '../CentralisedLink';
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../Redux/Auth/authActions';
import Swal from 'sweetalert2';
import UserProfileIcon from '../Images/User-icon-2.png'
import { partnerRoleService } from '../Pages/Dashboard/PartnerPortal/Services/partnerRoleService';
import { PAESalesNavbarLinks } from './PAENavbarLinks';
import { useFeatureFlags } from '../FeatureFlags/FeatureFlagsContext';
import { FEATURE_FLAGS } from '../FeatureFlags/featureFlagConstants';
import { canAccessStandaloneSeImpactAnalytics } from '../Pages/Dashboard/Analytics/SalesImpactAnalytics/seImpactAnalyticsAccess';

const SalesNavbarForHomePage = ({ activeTabSales }) => {

    const [showAnalyticsDropdown, setShowAnalyticsDropdown] = useState(false);
    const handleAnalyticsMouseEnter = () => setShowAnalyticsDropdown(true);
    const handleAnalyticsMouseLeave = () => {
        setTimeout(() => setShowAnalyticsDropdown(false), 200);
    };

    const dispatch = useDispatch();
    const currentUser = useSelector((state) => state.auth?.currentUser);
    const { isFeatureEnabled } = useFeatureFlags();
    const shouldShowPartnerPortal = partnerRoleService.hasPartnerPortalAccess(currentUser);
    const isPAERole = partnerRoleService.isPAERoleUser(currentUser);
    const shouldShowDemoCatalogue = (currentUser?.canDemo || isPAERole)
      && isFeatureEnabled(FEATURE_FLAGS.EnableDemoIngestions);
    const shouldShowBooking = (!(currentUser?.roleOfUser === 'IZOT' || currentUser?.roleOfUser === 'Leadership') || isPAERole)
      && isFeatureEnabled(FEATURE_FLAGS.EnableBookings);
    const shouldShowPartnerPortalNav = shouldShowPartnerPortal
      && isFeatureEnabled(FEATURE_FLAGS.EnablePartnerPortal);
    const shouldShowEnablementNav = isFeatureEnabled(FEATURE_FLAGS.EnableEnablement);
    const shouldShowContentStoreNav = isFeatureEnabled(FEATURE_FLAGS.EnableContentStore);
    const shouldShowFaqNav = isFeatureEnabled(FEATURE_FLAGS.EnableFAQ);
    const shouldShowAnalyticsNav = isFeatureEnabled(FEATURE_FLAGS.EnableAnalytics);

    const handleLogoutClick = () => {
        Swal.fire({
            title: "Are you sure you want to logout?",
            showCancelButton: true,
            confirmButtonText: "Logout",
            customClass: {
                title: 'my-custom-title-of-pop-login',
                confirmButton: 'my-custom-button-of-pop',
                cancelButton: 'card-cat-btn2'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(logout());
            }
        });
    };

    return (
        <>
            <nav className="custom-navbar navbar navbar-expand-lg navbar-transparent sticky">
                <div className="container">
                    <a className="navbar-brand" href="#">
                        <img src={BlackLogo} alt="Brand Logo" height="40" />
                    </a>

                    {/* Toggler Button */}
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNav"
                        aria-controls="navbarNav"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className={`navbar-nav ms-auto mb-2 mb-lg-0 ${isPAERole ? 'pae-navbar-nav' : ''}`}>
                            {isPAERole ? (
                                <PAESalesNavbarLinks
                                    activeTab={undefined}
                                    activeTabSales={activeTabSales}
                                    shouldShowDemoCatalogue={shouldShowDemoCatalogue}
                                    shouldShowBooking={shouldShowBooking}
                                    shouldShowPartnerPortal={shouldShowPartnerPortalNav}
                                    homeLinkId="nav-active"
                                />
                            ) : (
                                <>
                                    {activeTabSales === "HOME" ? (
                                        <li className="nav-item">
                                            <Link to='/home' className="nav-link" id='nav-active'>Home</Link>
                                        </li>
                                    ) : (
                                        <li className="nav-item">
                                            <Link to='/home' className="nav-link">Home</Link>
                                        </li>
                                    )}

                                    {shouldShowEnablementNav && (
                                      <li className="nav-item">
                                          <Link to={`${PATH.LEARNING_HUB_PATH}`} className="nav-link">LearningHub</Link>
                                      </li>
                                    )}
                                    {shouldShowContentStoreNav && (
                                      <li className="nav-item">
                                          <Link to={`${PATH.CONTENT_STORE_PATH}`} className="nav-link">Content Store</Link>
                                      </li>
                                    )}
                                    {shouldShowFaqNav && (
                                      <li className="nav-item">
                                          <Link to={`${PATH.FAQ_PATH}`} className="nav-link">FAQ</Link>
                                      </li>
                                    )}
                                </>
                            )}


                            {/* Nested Dropdown */}
                            <li class="nav-item dropdown">
                                {/* Profile Icon */}
                                <a class="nav-link" id="navbarDropdown2" role="button" data-bs-toggle="dropdown" data-bs-display="static" aria-expanded="false">
                                    <img className='homepage-user-profile-icon' src={UserProfileIcon} />
                                </a>
                                <ul class="dropdown-menu dropdown-menu-start" aria-labelledby="navbarDropdown2" id="content-drop">
                                    {/* Profile Nav */}
                                    <li>
                                        <Link
                                            to={`${PATH.PROFILE_PATH}`}
                                            className="dropdown-item-new no-link-style"
                                            id="myprfo">
                                            <i></i> My Profile
                                        </Link>
                                    </li>

                                    {shouldShowAnalyticsNav && canAccessStandaloneSeImpactAnalytics(currentUser) && (
                                        <li
                                            className="nav-item dropdown dropend"
                                            onMouseEnter={handleAnalyticsMouseEnter}
                                            onMouseLeave={handleAnalyticsMouseLeave}
                                        >
                                            <a
                                                role="button"
                                                className="dropdown-item-new no-link-style"
                                                aria-expanded={showAnalyticsDropdown}
                                                id="salesHomeAnalyticsDropdown"
                                            >
                                                <i class="fa-solid fa-angle-left"></i> Analytics
                                            </a>
                                            <ul
                                                className={`dropdown-menu-new dropdown-menu-end-new ${showAnalyticsDropdown ? 'show' : ''}`}
                                                aria-labelledby="salesHomeAnalyticsDropdown"
                                            >
                                                <li>
                                                    <Link
                                                        to={PATH.SE_ACTIVITIES_IMPACT_ANALYSIS_PATH}
                                                        className="dropdown-item-new no-link-style"
                                                    >
                                                        SE Activities & Impact Analysis
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li>
                                    )}

                                    <li>
                                        <a class="dropdown-item-new no-link-style" href="#" onClick={() => handleLogoutClick()}><i></i> Logout</a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
};

export default SalesNavbarForHomePage;
